import * as React from "react";

interface Props {
  color?: string;
  rotate?: boolean;
}
export const ExpandIcon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1rem"
    height="1rem"
    viewBox="0 0 10 4"
    className={props.rotate ? "rotate" : "not-rotate"}
  >
    <path
      d="M3.50001 2.58596L5.97501 0.110962L6.68201 0.817962L3.50001 3.99996L0.318006 0.817961L1.02501 0.110962L3.50001 2.58596Z"
      fill={props.color ?? "#424248"}
    />
  </svg>
);
